import { getFpId, getSourceFpId } from '../../../util/storageUtil'
import { xinStarCurrency, xinStarFpId } from '../config/customizedSetting'

const isXinStarFpId = (fpId: number): boolean => {
  return fpId === xinStarFpId
}

export const isXinStarCurrency = (currency: string): boolean => {
  return currency === xinStarCurrency
}

export const isXinStarPlayMode = () => {
  return isXinStarFpId(getFpId() ?? 0)
}

export const isXinStarDemoMode = () => {
  return getFpId() === 1680 && isXinStarFpId(getSourceFpId() ?? 0)
}

export const getIsXinStar = () => {
  const isXinStarPlay = isXinStarPlayMode()
  const isXinStarDemo = isXinStarDemoMode()
  return [isXinStarPlay || isXinStarDemo, isXinStarDemo]
}
